import _ from 'underscore';

var vmQualifyingProperties = ['value', 'aspects', '_propertyName', '_parent', '_ancestorChain', '_metadataInfo', '_accessorCode', '_aspects'];

var vmOwnProperties = vmQualifyingProperties.concat(['_aspectFactories']);

/**
 * Checks if maybenode is view model node.
 *
 * @param {*} maybeNode
 *
 * @returns {Boolean}
 */
function isVMNode(maybeNode) {
    if (!maybeNode || !_.isObject(maybeNode)) {
        return false;
    }

    return vmQualifyingProperties.every(function (qp) {
        return qp in maybeNode;
    });
}

function unpackIfVMNode(maybeNode) {
    if (isVMNode(maybeNode)) {
        return maybeNode.value;
    }

    return maybeNode;
}

/** Miscellaneous utilities for the view model nodes. */
export default {
    /** Checks if maybenode is view model node. */
    'isViewModelNode': isVMNode,
    'unpackIfViewModelNode': unpackIfVMNode,

    /**
     * Cleans item and extracts its true value.
     *
     * @param {*} maybeNode
     *
     * @returns {Boolean}
     */
    'cleanse': function cleanse(maybeNode) {
        return isVMNode(maybeNode) ? maybeNode.value : maybeNode;
    },

    iterateOverChildNodes: function iterateOverChildNodes(vmNode, cb) {
        Object.keys(vmNode).filter(function (key) {
            return !vmOwnProperties.includes(key);
        }).filter(function (key) {
            return isVMNode(vmNode[key]);
        }).forEach(function (key) {
            return cb(vmNode[key], key);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/ViewModelUtil.js
// module id = 71
// module chunks = 0